



















































































































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueForm from '@/components/Shared/GiganautVueForm';
import ActivityDto from '@/models/Activities/ActivityDto';
import ActivityCategoryDto from '@/models/Activities/ActivityCategoryDto';
import ActivityType, { ActivityTypeLabels } from '@/models/Activities/ActivityType';
import ActivityStatus, { ActivityStatusLabels } from '@/models/Activities/ActivityStatus';
import ActivityEntityType from '@/models/Activities/ActivityEntityType';
import ActivityDirection from '@/models/Activities/ActivityDirection';
import CallOutcome, { CallOutcomeLabels } from '@/models/Activities/CallOutcome';
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/modules/app';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import AgencyUserStatus from '@/models/AgencyUsers/AgencyUserStatus';

@Component({
    name: 'ActivityEdit'
})
export default class ActivityEdit extends GiganautVueForm {
    @Prop({ required: true })
    activity!: ActivityDto;

    @Prop({ default: false })
    visible!: boolean;

    entity: any = {};
    categories: ActivityCategoryDto[] = [];
    loadingCategories = false;
    saving = false;
    dueDateMenu = false;
    scheduledDateMenu = false;
    callDateMenu = false;

    get typeLabel(): string {
        return ActivityTypeLabels[this.activity.type] || 'Activity';
    }

    get statuses() {
        return [
            { value: ActivityStatus.Planned, label: ActivityStatusLabels[ActivityStatus.Planned] },
            { value: ActivityStatus.Completed, label: ActivityStatusLabels[ActivityStatus.Completed] },
            { value: ActivityStatus.Cancelled, label: ActivityStatusLabels[ActivityStatus.Cancelled] }
        ];
    }

    get priorities() {
        return [
            { value: 1, label: 'Low' },
            { value: 2, label: 'Normal' },
            { value: 3, label: 'High' },
            { value: 4, label: 'Urgent' }
        ];
    }

    get directions() {
        return [
            { value: ActivityDirection.Outbound, label: 'Outbound' },
            { value: ActivityDirection.Inbound, label: 'Inbound' }
        ];
    }

    get callOutcomes() {
        return [
            { value: CallOutcome.Connected, label: CallOutcomeLabels[CallOutcome.Connected] },
            { value: CallOutcome.NoAnswer, label: CallOutcomeLabels[CallOutcome.NoAnswer] },
            { value: CallOutcome.Engaged, label: CallOutcomeLabels[CallOutcome.Engaged] },
            { value: CallOutcome.Voicemail, label: CallOutcomeLabels[CallOutcome.Voicemail] }
        ];
    }

    get isTask(): boolean {
        return this.activity.type === ActivityType.Task;
    }

    get isCall(): boolean {
        return this.activity.type === ActivityType.Call;
    }

    get isMeeting(): boolean {
        return this.activity.type === ActivityType.Meeting;
    }

    get isNote(): boolean {
        return this.activity.type === ActivityType.Note;
    }

    get isEmail(): boolean {
        return this.activity.type === ActivityType.Email;
    }

    get subjectRequired(): boolean {
        return this.isTask || this.isCall || this.isMeeting || this.isEmail;
    }

    get activeUsers() {
        return AgencySettingsModule.agencyUsers.filter(
            user => user.status === AgencyUserStatus.Active
        );
    }

    get branches() {
        return AgencySettingsModule.branches;
    }

    get filteredDesks() {
        if (!this.entity.branchId) return [];
        const branch = AgencySettingsModule.branches.find((b: any) => b.id === this.entity.branchId);
        return branch?.desks || [];
    }

    onBranchChanged() {
        this.entity.deskId = null;
        const desks = this.filteredDesks;
        if (desks.length === 1) {
            this.entity.deskId = desks[0].id;
        }
    }

    /**
     * Returns categories filtered by the activity's type and entity type.
     */
    get filteredCategories(): ActivityCategoryDto[] {
        const activityType = this.activity?.type;
        const entityType = this.activity?.primaryEntityType;

        if (!activityType) return this.categories;

        return this.categories.filter(category => {
            if (!category.isActive) return false;
            return this.isCategoryEnabledFor(category, entityType, activityType);
        });
    }

    /**
     * Checks if a category is enabled for a specific entity type and activity type combination.
     */
    isCategoryEnabledFor(category: ActivityCategoryDto, entityType: ActivityEntityType | null | undefined, activityType: ActivityType): boolean {
        if (entityType === null || entityType === undefined) return true;

        let activitySuffix = '';
        switch (activityType) {
            case ActivityType.Task: activitySuffix = 'Task'; break;
            case ActivityType.Note: activitySuffix = 'Note'; break;
            case ActivityType.Call: activitySuffix = 'Call'; break;
            case ActivityType.Meeting: activitySuffix = 'Meeting'; break;
            case ActivityType.Email: activitySuffix = 'Email'; break;
            default: return true;
        }

        let entityPrefix = '';
        switch (entityType) {
            case ActivityEntityType.Worker: entityPrefix = 'Worker'; break;
            case ActivityEntityType.Company: entityPrefix = 'Company'; break;
            case ActivityEntityType.Location: entityPrefix = 'Location'; break;
            case ActivityEntityType.Contact: entityPrefix = 'Contact'; break;
            case ActivityEntityType.Job: entityPrefix = 'Job'; break;
            case ActivityEntityType.Booking: entityPrefix = 'Booking'; break;
            case ActivityEntityType.Campaign: entityPrefix = 'Campaign'; break;
            case ActivityEntityType.Opportunity: entityPrefix = 'Opportunity'; break;
            default: return true;
        }

        const fieldName = `isEnabledOn${entityPrefix}${activitySuffix}` as keyof ActivityCategoryDto;
        return category[fieldName] === true;
    }

    getUserAvatarUrl(userId: string, avatar: string): string {
        if (!avatar) return '';
        return AppModule.currentAgencyContext.storageSharedBaseUrl + '/avatars/2/' + userId + '/resized-100/' + avatar;
    }

    // --- Task due date (endAt) computed properties ---
    get formattedDueDate(): string {
        if (!this.entity.endAt) return '';
        return new Date(this.entity.endAt).toLocaleDateString();
    }

    get dueDatePicker(): string {
        if (!this.entity.endAt) return '';
        return new Date(this.entity.endAt).toISOString().substr(0, 10);
    }

    set dueDatePicker(val: string) {
        if (!val) {
            this.entity.endAt = null;
            return;
        }
        const existing = this.entity.endAt ? new Date(this.entity.endAt) : null;
        const hours = existing ? existing.getHours() : 9;
        const minutes = existing ? existing.getMinutes() : 0;
        const d = new Date(val);
        d.setHours(hours, minutes, 0, 0);
        this.entity.endAt = d;
    }

    get dueTime(): string {
        if (!this.entity.endAt) return '09:00';
        const d = new Date(this.entity.endAt);
        return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    }

    set dueTime(val: string) {
        if (!val) return;
        const parts = val.split(':');
        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10);
        const d = this.entity.endAt ? new Date(this.entity.endAt) : new Date();
        d.setHours(hours, minutes, 0, 0);
        this.entity.endAt = d;
    }

    // --- Meeting date/time computed properties ---
    get formattedMeetingDate(): string {
        if (!this.entity.startAt) return '';
        return new Date(this.entity.startAt).toLocaleDateString();
    }

    get meetingDatePicker(): string {
        if (!this.entity.startAt) return '';
        return new Date(this.entity.startAt).toISOString().substr(0, 10);
    }

    set meetingDatePicker(val: string) {
        if (!val) {
            this.entity.startAt = null;
            this.entity.endAt = null;
            return;
        }
        const existingStart = this.entity.startAt ? new Date(this.entity.startAt) : null;
        const startHours = existingStart ? existingStart.getHours() : 9;
        const startMinutes = existingStart ? existingStart.getMinutes() : 0;
        const startDate = new Date(val);
        startDate.setHours(startHours, startMinutes, 0, 0);
        this.entity.startAt = startDate;

        const existingEnd = this.entity.endAt ? new Date(this.entity.endAt) : null;
        const endHours = existingEnd ? existingEnd.getHours() : 10;
        const endMinutes = existingEnd ? existingEnd.getMinutes() : 0;
        const endDate = new Date(val);
        endDate.setHours(endHours, endMinutes, 0, 0);
        this.entity.endAt = endDate;
    }

    get meetingStartTime(): string {
        if (!this.entity.startAt) return '09:00';
        const d = new Date(this.entity.startAt);
        return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    }

    set meetingStartTime(val: string) {
        if (!val) return;
        const parts = val.split(':');
        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10);
        const d = this.entity.startAt ? new Date(this.entity.startAt) : new Date();
        d.setHours(hours, minutes, 0, 0);
        this.entity.startAt = d;
    }

    get meetingEndTime(): string {
        if (!this.entity.endAt) return '10:00';
        const d = new Date(this.entity.endAt);
        return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    }

    set meetingEndTime(val: string) {
        if (!val) return;
        const parts = val.split(':');
        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10);
        const baseDate = this.entity.startAt ? new Date(this.entity.startAt) : new Date();
        const d = new Date(baseDate);
        d.setHours(hours, minutes, 0, 0);
        this.entity.endAt = d;
    }

    clearMeetingDate() {
        this.entity.startAt = null;
        this.entity.endAt = null;
    }

    // --- Call date/time computed properties ---
    get formattedCallDate(): string {
        if (!this.entity.startAt) return '';
        return new Date(this.entity.startAt).toLocaleDateString();
    }

    get callDatePicker(): string {
        if (!this.entity.startAt) return '';
        return new Date(this.entity.startAt).toISOString().substr(0, 10);
    }

    set callDatePicker(val: string) {
        if (!val) {
            this.entity.startAt = null;
            this.entity.endAt = null;
            return;
        }
        const existingStart = this.entity.startAt ? new Date(this.entity.startAt) : null;
        const startHours = existingStart ? existingStart.getHours() : 9;
        const startMinutes = existingStart ? existingStart.getMinutes() : 0;
        const startDate = new Date(val);
        startDate.setHours(startHours, startMinutes, 0, 0);
        this.entity.startAt = startDate;

        const existingEnd = this.entity.endAt ? new Date(this.entity.endAt) : null;
        const endHours = existingEnd ? existingEnd.getHours() : 10;
        const endMinutes = existingEnd ? existingEnd.getMinutes() : 0;
        const endDate = new Date(val);
        endDate.setHours(endHours, endMinutes, 0, 0);
        this.entity.endAt = endDate;
    }

    clearCallDate() {
        this.entity.startAt = null;
        this.entity.endAt = null;
    }

    get callStartTime(): string {
        if (!this.entity.startAt) return '09:00';
        const d = new Date(this.entity.startAt);
        return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    }

    set callStartTime(val: string) {
        if (!val) return;
        const parts = val.split(':');
        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10);
        const d = this.entity.startAt ? new Date(this.entity.startAt) : new Date();
        d.setHours(hours, minutes, 0, 0);
        this.entity.startAt = d;
    }

    get callEndTime(): string {
        if (!this.entity.endAt) return '10:00';
        const d = new Date(this.entity.endAt);
        return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    }

    set callEndTime(val: string) {
        if (!val) return;
        const parts = val.split(':');
        const hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10);
        const baseDate = this.entity.startAt ? new Date(this.entity.startAt) : new Date();
        const d = new Date(baseDate);
        d.setHours(hours, minutes, 0, 0);
        this.entity.endAt = d;
    }

    @Watch('visible', { immediate: true })
    async onVisibleChanged(val: boolean) {
        if (val && this.activity) {
            this.populateEntity();

            // Load categories if not already loaded
            if (this.categories.length === 0) {
                await this.loadCategories();
            }
            // Load agency users and branches if not already loaded
            if (AgencySettingsModule.agencyUsers.length === 0) {
                await AgencySettingsModule.getAgencyUsers();
            }
            if (AgencySettingsModule.branches.length === 0) {
                await AgencySettingsModule.getBranches();
            }
        }
    }

    @Watch('activity', { immediate: true })
    onActivityChanged() {
        // Re-populate entity if activity changes while dialog is open
        if (this.visible && this.activity) {
            this.populateEntity();
        }
    }

    populateEntity() {
        // Copy all relevant fields from activity to entity
        this.entity = {
            status: this.activity.status,
            subject: this.activity.subject,
            body: this.activity.body,
            categoryId: this.activity.categoryId,
            branchId: this.activity.branchId,
            deskId: this.activity.deskId,
            ownerId: this.activity.ownerId,
            startAt: this.activity.startAt,
            endAt: this.activity.endAt,
            taskPriority: this.activity.taskPriority,
            direction: this.activity.direction,
            phoneNumber: this.activity.phoneNumber,
            callOutcome: this.activity.callOutcome,
            meetingLocation: this.activity.meetingLocation,
            meetingOnlineUrl: this.activity.meetingOnlineUrl,
            meetingIsOnline: this.activity.meetingIsOnline || false,
            updatedAt: this.activity.updatedAt
        };
    }

    async loadCategories() {
        this.loadingCategories = true;
        try {
            const response = await ajax.get('/api/v1/agency/activity-categories');
            this.categories = response.data || [];
        } catch (error) {
            // Silent fail - categories are optional
        } finally {
            this.loadingCategories = false;
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }

        this.saving = true;
        try {
            const activityId = this.activity.id;
            const baseUrl = `/api/v1/agency/activities/${activityId}`;

            // Note details
            if (this.isNote) {
                await ajax.put(`${baseUrl}/note-details`, {
                    body: this.entity.body || '',
                    categoryId: this.entity.categoryId || null,
                    branchId: this.entity.branchId || null,
                    deskId: this.entity.deskId || null,
                    updatedAt: this.entity.updatedAt
                });
            }

            // Task details
            else if (this.isTask) {
                const request: any = {
                    subject: this.entity.subject,
                    body: this.entity.body || '',
                    categoryId: this.entity.categoryId || null,
                    branchId: this.entity.branchId || null,
                    deskId: this.entity.deskId || null,
                    ownerId: this.entity.ownerId || null,
                    taskPriority: this.entity.taskPriority,
                    status: this.entity.status,
                    updatedAt: this.entity.updatedAt
                };
                if (this.entity.endAt) {
                    const endDate = this.entity.endAt instanceof Date ? this.entity.endAt : new Date(this.entity.endAt);
                    request.endAt = endDate.toISOString();
                }
                await ajax.put(`${baseUrl}/task-details`, request);
            }

            // Call details
            else if (this.isCall) {
                const request: any = {
                    subject: this.entity.subject,
                    body: this.entity.body || '',
                    categoryId: this.entity.categoryId || null,
                    branchId: this.entity.branchId || null,
                    deskId: this.entity.deskId || null,
                    direction: this.entity.direction,
                    phoneNumber: this.entity.phoneNumber || '',
                    callOutcome: this.entity.callOutcome,
                    updatedAt: this.entity.updatedAt
                };
                if (this.entity.startAt) {
                    const startDate = this.entity.startAt instanceof Date ? this.entity.startAt : new Date(this.entity.startAt);
                    request.startAt = startDate.toISOString();
                }
                if (this.entity.endAt) {
                    const endDate = this.entity.endAt instanceof Date ? this.entity.endAt : new Date(this.entity.endAt);
                    request.endAt = endDate.toISOString();
                }
                await ajax.put(`${baseUrl}/call-details`, request);
            }

            // Meeting details
            else if (this.isMeeting) {
                const request: any = {
                    subject: this.entity.subject,
                    body: this.entity.body || '',
                    categoryId: this.entity.categoryId || null,
                    branchId: this.entity.branchId || null,
                    deskId: this.entity.deskId || null,
                    meetingLocation: this.entity.meetingLocation || '',
                    meetingIsOnline: this.entity.meetingIsOnline || false,
                    meetingOnlineUrl: this.entity.meetingOnlineUrl || '',
                    updatedAt: this.entity.updatedAt
                };
                if (this.entity.startAt) {
                    const startDate = this.entity.startAt instanceof Date ? this.entity.startAt : new Date(this.entity.startAt);
                    request.startAt = startDate.toISOString();
                }
                if (this.entity.endAt) {
                    const endDate = this.entity.endAt instanceof Date ? this.entity.endAt : new Date(this.entity.endAt);
                    request.endAt = endDate.toISOString();
                }
                await ajax.put(`${baseUrl}/meeting-details`, request);
            }

            // Email details
            else if (this.isEmail) {
                await ajax.put(`${baseUrl}/email-details`, {
                    subject: this.entity.subject,
                    body: this.entity.body || '',
                    categoryId: this.entity.categoryId || null,
                    branchId: this.entity.branchId || null,
                    deskId: this.entity.deskId || null,
                    updatedAt: this.entity.updatedAt
                });
            }

            this.$emit('saved');
        } catch (error) {
            AppModule.handleApiError(error);
        } finally {
            this.saving = false;
        }
    }
}
